import React from 'react';

import { useHistory } from 'react-router-dom';
import { useStore } from '../../providers/AppProvider';

import { faSignOutAlt, faThList, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown, Navbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import OrgLogo from './OrgLogo';
import datumLogoNoText from '../../../../assets/img/datum_logo_notext.svg';
import SeasonSelector from '../../features/fields/components/show/SeasonSelector';

type NavProps = {}

const TopNavigation = ({}: NavProps) => {
    const history = useHistory();
    const { currentUser, userOrgs, refreshAllCredentials } = useStore();

    async function handleOrgSwitch(org: any) {
        await refreshAllCredentials(org.orgId);
        console.log("history", history) // field manager
        history.push("/switchOrgs");
    }

    
    const orgOptionLinks = () => {
        if (!userOrgs || userOrgs.length === 0) {
            return null;
        }

        return (userOrgs.map((userOrg: any, i: number) => {
            return (
              <Dropdown.Item onClick={() => handleOrgSwitch(userOrg)} key={i}>
                {userOrg.orgName}
              </Dropdown.Item>
            );
          })
        );
    }


    const renderTooltip = (messageTooltip: String) => {
        return (
            <Tooltip id="button-tooltip">
                 {messageTooltip}
            </Tooltip>
        );
    }


    const renderButtons = () => {
        return (<span>
            <OverlayTrigger placement="bottom" delay={{ show: 100, hide: 200 }} overlay={renderTooltip("Dashboard list")}>
                <Button className="dashboard-icon-button" variant="secondary" key="dashboard-list" href={`/`}>
                    {/*<FontAwesomeIcon icon={faThList} />*/}
                    <img
                        src={datumLogoNoText}
                        width="18px"
                        style={{paddingBottom: "3px"}}
                        className="d-inline-block align-middle logo-padding"
                        alt={"Datum Geospatial"}
                    />
                </Button>
            </OverlayTrigger>
        </span>);
    }


    const renderProfileButton = () => {
        let logoutElement;

        if (currentUser && currentUser.userId) {
            logoutElement = (
                <span>
                    <Dropdown.Item eventKey="1" href="/logout">
                        <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                    </Dropdown.Item>
                </span>
            );
        } 

        const orgLinks = orgOptionLinks();

        return(
            <Dropdown alignRight className="dropdown profile">
                <Dropdown.Toggle variant="secondary	" id="profile-dropdown">
                    <FontAwesomeIcon icon={faUser} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {logoutElement}
                    {currentUser && currentUser.userId && orgLinks ?
                    <>
                        <Dropdown.Divider/>
                        {orgLinks}
                    </> : null
                    }
                </Dropdown.Menu>          
            </Dropdown>
        );
    }


    return (
        <Navbar 
            variant="light" 
            sticky="top" 
            bg="light" 
            expand="lg" 
            id="field-mgr-header" 
            style={{backgroundColor:"#ffffff", color:"#343a40"}}
            className="w-100 justify-content-between px-2 py-2 border border-left-0 border-right-0 border-top-o border-secondary"
        >
          <div className="align-items-center d-flex">
            <OrgLogo name={currentUser.orgName} bgColor={currentUser.orgLogoBground} logo={currentUser.orgLogo} /> 
            <span className="ml-3 text-2xl">{currentUser.orgName}</span>
            <SeasonSelector /> 
          </div>
          <Navbar.Collapse>
          </Navbar.Collapse>
          <div className="d-flex">
            {renderButtons()}
            {renderProfileButton()}
          </div>
        </Navbar>
    );
}


export default TopNavigation;